import React, {useContext, useEffect, useState} from 'react';
import {PAContext} from "../../../Services/PAContext";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {Card, CardActions, CardContent, Checkbox, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator
} from "@mui/lab";

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
dayjs.extend(utc);
dayjs.extend(duration);








const FlightSelectionFromSearch = ({ searchResults, flightMode, flightsOnMap, setFlightsOnMap,
                                       selectedFlights, setSelectedFlights }) => {

    const { PA_GlobalObject} = usePA_GlobalStore();

    const { dataArray } = useContext(PAContext);
    const { Account, Attendees, SampleAttendees } = dataArray; // Fetch event attendees

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( dataArray.authenticated && !PA_GlobalObject.Planning.is_template
        ? Attendees
        : SampleAttendees);
    useEffect(() => {
        setAttendeesReferenceArray(
            dataArray.authenticated
                ? Attendees
                : SampleAttendees
        );
    }, [dataArray.authenticated, Attendees, SampleAttendees]);

    const [filteredFlights, setFilteredFlights] = useState(searchResults);

    // Effect to reset filteredFlights when flights change
    useEffect(() => {
        setFilteredFlights(searchResults);
    }, [searchResults]);



    const calculateFlightDuration = (departTs, departOffset, arriveTs, arriveOffset) => {
        // Create Day.js objects in UTC and apply timezone offsets
        const depart = dayjs.utc(departTs).add(departOffset, 'hour');
        const arrive = dayjs.utc(arriveTs).add(arriveOffset, 'hour');

        // Calculate difference in milliseconds
        const diffMs = arrive.diff(depart);

        // Convert to hours and minutes
        const dur = dayjs.duration(diffMs);
        return `${dur.hours()}h ${dur.minutes()}m`;
    };




    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            {/* Sticky Header */}
            <div style={{
                position: 'sticky',
                top: 0,
                backgroundColor: 'white',
                zIndex: 1,
                padding: '5px 10px',   // Reduce padding for the header
                height: 'auto',        // Let the content define the height
            }}>

                {/* Flex container for the header */}
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    {/* Left-aligned available flights text */}
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <Typography sx={{fontSize: '16px'}}>
                            Available Flights ({filteredFlights.length})
                        </Typography>
                    </div>
                </div>
            </div>

            {/* Scrollable List of Flights as Cards */}
            <div style={{flex: 1, overflowY: 'auto'}}>
                <Grid container spacing={2}>
                    {filteredFlights.length ? (
                        filteredFlights.map((flight, idx) => {

                            // Format functions
                            const formatTime = (timestamp) => dayjs(timestamp).format("HH:mm");
                            const formatDate = (timestamp) => dayjs(timestamp).format("D MMM");

                            // Check if day changes
                            const departDayChange = dayjs(flight.depart_timestamp).format("YYYY-MM-DD") !== dayjs(flight.arrive_timestamp).format("YYYY-MM-DD");

                            return (
                                <Card
                                    key={idx}
                                    variant="outlined"
                                    sx={{
                                        backgroundColor: selectedFlights[flightMode].some(f => f.id === flight.id) ? 'beige' : 'white'
                                    }}
                                >
                                    <CardContent>
                                        {/* Carrier Name & Flight Number */}
                                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                {flight.airline_name}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                #{flight.flight_number}
                                            </Typography>
                                        </Box>

                                        {/* Flight Duration */}
                                        <Box sx={{ textAlign: 'right', mb: 2 }}>
                                            <Typography variant="body2" color="textSecondary">
                                                In Flight: {calculateFlightDuration(flight.depart_timestamp, flight.depart_timezone_offset, flight.arrive_timestamp, flight.arrive_timezone_offset)}
                                            </Typography>
                                        </Box>

                                        {/* Timeline */}
                                        <Timeline sx={{ padding: 0, marginTop: 1 }}>
                                            <TimelineItem>
                                                <TimelineOppositeContent sx={{ flex: 0.5, textAlign: "right", pr: 1 }}>
                                                    <Typography variant="caption" sx={{ fontWeight: "bold", color: "gray" }}>
                                                        {dayjs(flight.depart_timestamp).format('h:mm A')}
                                                    </Typography>
                                                </TimelineOppositeContent>
                                                <TimelineSeparator>
                                                    <TimelineDot color="info">
                                                        <i className="icon-airplane" style={{ fontSize: '1rem' }} />
                                                    </TimelineDot>
                                                    <TimelineConnector />
                                                </TimelineSeparator>
                                                <TimelineContent>
                                                    <Typography variant="body2" sx={{ paddingTop: '10px' }}>
                                                        {flight.depart_airport_name}
                                                    </Typography>
                                                    {departDayChange && (
                                                        <Typography variant="caption" color="textSecondary">
                                                            {formatDate(flight.depart_timestamp)}
                                                        </Typography>
                                                    )}
                                                </TimelineContent>
                                            </TimelineItem>

                                            <TimelineItem>
                                                <TimelineOppositeContent sx={{ flex: 0.5, textAlign: "right", pr: 1 }}>
                                                    <Typography variant="caption" sx={{ fontWeight: "bold", color: "gray" }}>
                                                        {dayjs(flight.arrive_timestamp).format('h:mm A')}
                                                    </Typography>
                                                </TimelineOppositeContent>
                                                <TimelineSeparator>
                                                    <TimelineDot color="info">
                                                        <i className="icon-airplane" style={{ fontSize: '1rem', transform: 'rotate(90deg)' }} />
                                                    </TimelineDot>
                                                </TimelineSeparator>
                                                <TimelineContent>
                                                    <Typography variant="body2" sx={{ paddingTop: '10px' }}>
                                                        {flight.arrive_airport_name}
                                                    </Typography>
                                                    {departDayChange && (
                                                        <Typography variant="caption" color="textSecondary">
                                                            {formatDate(flight.arrive_timestamp)}
                                                        </Typography>
                                                    )}
                                                </TimelineContent>
                                            </TimelineItem>
                                        </Timeline>
                                    </CardContent>

                                    <CardActions>
                                        {/* Map It */}
                                        <Box display="flex" flexGrow={1} alignItems="center">
                                            <Checkbox
                                                checked={flightsOnMap.some(f => f.id === flight.id)}
                                                onChange={() => {
                                                    const isChecked = flightsOnMap.some(f => f.id === flight.id);
                                                    setFlightsOnMap(isChecked ? flightsOnMap.filter(f => f.id !== flight.id) : [...flightsOnMap, flight]);
                                                }}
                                            />
                                            <Typography variant="button">Map It</Typography>
                                        </Box>

                                        {/* Select It */}
                                        <Box display="flex" flexGrow={1} alignItems="center">
                                            <Checkbox
                                                checked={selectedFlights[flightMode].some(f => f.id === flight.id)}
                                                onChange={() => {
                                                    const isChecked = selectedFlights[flightMode].some(f => f.id === flight.id);
                                                    setSelectedFlights({
                                                        ...selectedFlights,
                                                        [flightMode]: isChecked
                                                            ? selectedFlights[flightMode].filter(f => f.id !== flight.id)
                                                            : [...selectedFlights[flightMode], flight]
                                                    });
                                                }}
                                            />
                                            <Typography variant="button">Select It</Typography>
                                        </Box>
                                    </CardActions>
                                </Card>
                            );
                        })
                    ) : (
                        <Typography>No flights available.</Typography>
                    )}
                </Grid>

            </div>
        </div>
    )
};

export default FlightSelectionFromSearch;